<template>
  <div>
    <input
      type="range"
      class="slider-container"
      :min="min"
      :max="max"
      :value="numberShown"
      :style="sliderStyle"
      :step="step"
      @input="$emit('input', $event.target.value)"
    />

    <span class="text">{{ sliderText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    numberShown: {
      type: Number,
      required: true
    },
    sliderText: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 5
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    backgroundColor: {
      type: String,
      default: '#eeeeee'
    },
    filledColor: {
      type: String,
      default: '#b4a4e3'
    }
  },
  computed: {
    sliderStyle() {
      return {
        // eslint-disable-next-line max-len
        background: `linear-gradient(to right, ${this.filledColor} 0%, ${this.filledColor} ${
          this.numberShown * (100 / this.max)
        }%, ${this.backgroundColor} ${this.numberShown * (100 / this.max)}%, ${
          this.backgroundColor
        } 100%)`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-container {
  --track-height: 0.5em;
  --slider-thumb-size: 1.3em;
  --slider-thumb-radius: 50%;

  background: $softPurple;
  -webkit-appearance: none;
  width: calc(100% - 3.5em);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: var(--track-height);
  border-radius: 0.2em;
  margin-right: 0.2em;

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    height: var(--track-height);
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    margin-top: 0;

    background-color: #b4a4e3;
    height: var(--slider-thumb-size);
    width: var(--slider-thumb-size);
    border-radius: var(--slider-thumb-radius);

    transition: box-shadow 0.3s;
    box-shadow: 0px 0px 0px 0px transparent;
  }
  &::-moz-range-thumb {
    border: none;
    border-radius: 0;

    background-color: #b4a4e3;
    height: var(--slider-thumb-size);
    width: var(--slider-thumb-size);
    border-radius: var(--slider-thumb-radius);

    transition: box-shadow 0.3s;
    box-shadow: 0px 0px 0px 0px transparent;
  }
}
.text {
  color: #707070;
  font-size: 0.9em;
  display: inline-block;
  width: 40px;
}
</style>
